import moment from 'moment';
import React from 'react';

const WorkSheetTable = ({ data = [] }) => {
  const T_Head = ["#", "Date", "Employee Name", "Work Detail"];

  // console.log(data)
  const groupedByDept = data.reduce((acc, item) => {
    const dept = item.DEPT?.trim() || "Unknown Department";

    if (!acc[dept]) acc[dept] = [];
    acc[dept].push(item);

    return acc;
  }, {});
  // console.log(groupedByDept)
  return (
    <div className="font-[sans-serif] overflow-x-auto">
      <table className="min-w-full bg-white dark:bg-darkgray">
        <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
          <tr>
            {T_Head.map((item, index) => (
              <th
                key={index}
                className="p-4 text-left text-sm md:text-lg font-bold text-white"
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="whitespace-nowrap">
          {data.length === 0 ? (
            <tr>
              <td colSpan={4}>
                <div className="min-h-[300px] flex items-center justify-center">
                  <p className="animate-pulse text-gray-500">
                    No Data Available
                  </p>
                </div>
              </td>
            </tr>
          ) : (
            Object.entries(groupedByDept).map(([dept, rows], deptIndex) => (
              <React.Fragment key={deptIndex}>
                {/* 🔹 Department Row */}
                <tr className="bg-gray-200 dark:bg-gray-900">
                  <td colSpan={4} className="p-4 font-bold text-gray-800 dark:text-white">
                    {dept}
                  </td>
                </tr>

                {/* 🔹 Department Employees */}
                {rows.map((item, index) => (
                  <tr
                    key={index}
                    className="even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800
                           text-gray-900 dark:text-gray-200 text-sm"
                  >
                    <td className="p-4">{index + 1}</td>
                    <td className="p-4">
                      {moment(item.WORK_DATE).format("DD MMMM YYYY")}
                    </td>
                    <td className="p-4">{item.FIRSTNAME}</td>
                    <td className="p-4">
                      {item.WORK_DETAIL || (
                        <span className="italic text-gray-400">No work detail</span>
                      )}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>
    </div>

  );
};

export default WorkSheetTable;
// import moment from 'moment';
// import React from 'react';

// const WorkSheetTable = ({ data = [] }) => {
//   const T_Head = ["#", "Date", "Employee Name", "Work Detail"];

//   // console.log(data)

//   return (
//     <div className="font-[sans-serif] overflow-x-auto">
//       <table className="min-w-full bg-white dark:bg-darkgray">
//         <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
//           <tr>
//             {T_Head.map((item, index) => (
//               <th
//                 className="p-4 text-left text-sm md:text-lg font-bold text-white"
//                 key={index}
//               >
//                 {item}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody className="whitespace-nowrap">
//           { data.length === 0 ? 
//            ( <tr className="bg-gray-50 dark:bg-gray-900">
//                 <td colSpan={4}>
//                   <div className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
//                     flex flex-col items-center justify-center
//                     text-center gap-2">
//                     <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-white">
//                        No Data Available
//                     </p>
//                     <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
//                       Please check back later or try refreshing.
//                     </p>
//                   </div>
//                 </td>
//               </tr>
//           ) : data?.map((item, index) => (
//               <tr className="even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800  text-gray-900 dark:text-gray-200 text-sm" key={index}>
//                 <td className="p-4">{index + 1}</td>
//                 <td className="p-4">{ moment(item?.WORK_DATE).format("DD MMMM YYYY")}</td>
//                 <td className="p-4">{ item?.FIRSTNAME}</td>
//                 <td className="p-4">{ item?.WORK_DETAIL}</td>
//               </tr>
              
//             ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default WorkSheetTable;

